import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'
import { isNrwVisible } from '@/utils/featureHosts'
import { NODE_BASE, commonHeaders } from '@/api/http'
//import { useAuthStore } from '@/stores/authStore'

const router = createRouter({
  history: createWebHistory(),
  //history: createWebHistory('/renewal/'),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
    },
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/DashboardView.vue'),
      meta: { titleKey: 'nav.monitoring' },
    },
    {
      path: '/water-leak',
      name: 'water-leak',
      component: () => import('@/views/LeakDetectionView.vue'),
      meta: { titleKey: 'nav.leak' },
    },
    {
      path: '/logger',
      name: 'logger',
      component: () => import('@/views/LoggerView.vue'),
      meta: { titleKey: 'nav.logger' },
    },
    {
      path: '/gis-master',
      name: 'gis-master',
      component: () => import('@/views/GisMasterView.vue'),
      meta: { titleKey: 'nav.gis_master' },
    },
    {
      path: '/dma',
      name: 'dma',
      component: () => import('@/views/DmaView.vue'),
      meta: { titleKey: 'nav.gis_master' },
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: () => import('@/views/MaintenanceView.vue'),
      meta: { titleKey: 'nav.maintenance' },
    },
    // NRW — 로컬은 항상, 운영은 dev.neverlosewater.com + 고객사 0·16 만. LeftNav 노출 조건과 동일하게 beforeEach 에서 가드
    {
      path: '/nrw',
      name: 'nrw',
      component: () => import('@/views/NrwView.vue'),
      meta: { titleKey: 'nav.nrw', nrwOnly: true },
    },
    {
      path: '/similar-sites',
      name: 'similar-sites',
      component: () => import('@/views/SimilarSitesView.vue'),
      meta: { titleKey: 'header.similar_sites' },
    },
    // AI Agent — 관리자(customer_id===1) 전용 풀스크린 화면. router.beforeEach 에서 권한 가드
    {
      path: '/agent-ai',
      name: 'agent-ai',
      component: () => import('@/views/AiAgentView.vue'),
      meta: { titleKey: 'nav.ai_agent', adminOnly: true },
    },
    // 관리자 메뉴 — 고객사가 Wiplat 인 경우만 헤더에 노출 (실제 화면은 후속)
    {
      path: '/admin/customers',
      name: 'admin-customers',
      component: () => import('@/views/admin/CustomerView.vue'),
      meta: { titleKey: 'header.admin_customers' },
    },
    {
      path: '/admin/workers',
      name: 'admin-workers',
      component: () => import('@/views/admin/WorkerView.vue'),
      meta: { titleKey: 'header.admin_workers' },
    },
    {
      path: '/admin/devices',
      name: 'admin-devices',
      component: () => import('@/views/admin/DeviceView.vue'),
      meta: { titleKey: 'header.admin_devices' },
    },
    {
      path: '/admin/alarms',
      name: 'admin-alarms',
      component: () => import('@/views/admin/AlarmView.vue'),
      meta: { titleKey: 'header.admin_alarms' },
    },
    {
      path: '/admin/mnp',
      name: 'admin-mnp',
      component: () => import('@/views/admin/MnpView.vue'),
      meta: { titleKey: 'header.admin_mnp' },
    },
    {
      path: '/admin/press-datacheck',
      name: 'admin-press-datacheck',
      component: () => import('@/views/admin/DataCheckView.vue'),
      meta: { titleKey: 'header.admin_press_datacheck' },
    },
  ],
})

// 서버에 토큰이 아직 유효한지 묻는다 — 페이지를 새로 읽은 뒤(또는 새 토큰으로) 처음 이동할 때 한 번만
//   공용 api 인스턴스는 401 에서 logout() 으로 router.push 를 하므로, 가드 안에서는 기본 axios 로 직접 호출한다
//   401·403 만 만료로 보고, 네트워크 오류·5xx 는 서버 장애일 수 있어 통과시킨다
let checkedToken = null
async function isTokenValid(token) {
  if (checkedToken === token) return true
  try {
    await axios.get(NODE_BASE + 'api/auth_check', { headers: commonHeaders(token) })
  } catch (err) {
    const status = err.response?.status
    if (status === 401 || status === 403) return false
  }
  checkedToken = token
  return true
}

router.beforeEach(async (to) => {
  const accessToken = sessionStorage.accessToken
  if (to.name === 'login') {
    if (accessToken) {
      const redirect = typeof to.query.redirect === 'string' ? to.query.redirect : '/'
      if (redirect.startsWith('/api/') || redirect.startsWith('/node/api/')) return { name: 'dashboard' }
      return redirect
    }
    return true
  }

  if (!accessToken) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  // 토큰이 만료됐으면 세션을 비우고 로그인으로 (authStore.logout 과 같은 정리)
  if (!(await isTokenValid(accessToken))) {
    try { sessionStorage.clear() } catch { /* noop */ }
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  // adminOnly 라우트 — 로그인 사용자의 home customer_id 가 1(Wiplat)인 경우에만 진입
  if (to.meta?.adminOnly && Number(sessionStorage.customer_id) !== 1) {
    return { name: 'dashboard' }
  }

  // nrwOnly 라우트 — 로컬은 항상, 운영은 dev.neverlosewater.com + 고객사 0·16 일 때만 진입 (주소 직접 입력도 차단)
  if (to.meta?.nrwOnly && !isNrwVisible()) {
    return { name: 'dashboard' }
  }

  return true
})

export default router
